import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

export default function EmailIcon({ fill = '#5124A6' }) {
    return (
        <SvgIcon style={{ width: 48, height: 48 }}>
            <svg width="51" height="48" viewBox="0 0 51 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="49.8" height="47" rx="7.5" stroke={fill} />
                <path
                    d="M17.0273 32.3535C16.4855 32.3535 16.02 32.1589 15.6308 31.7696C15.2415 31.3803 15.0469 30.9148 15.0469 30.373V17.6274C15.0469 17.0817 15.2415 16.6129 15.6308 16.2208C16.02 15.8288 16.4855 15.6328 17.0273 15.6328H33.773C34.3186 15.6328 34.7875 15.8288 35.1795 16.2208C35.5715 16.6129 35.7675 17.0817 35.7675 17.6274V30.373C35.7675 30.9148 35.5715 31.3803 35.1795 31.7696C34.7875 32.1589 34.3186 32.3535 33.773 32.3535H17.0273ZM33.773 19.3274L25.9429 24.528C25.8488 24.5805 25.7603 24.6216 25.6776 24.6513C25.5948 24.681 25.5023 24.6959 25.4001 24.6959C25.298 24.6959 25.2055 24.681 25.1227 24.6513C25.04 24.6216 24.9515 24.5805 24.8574 24.528L17.0273 19.3274V30.373H33.773V19.3274ZM25.4001 23.0774L33.673 17.6274H17.1523L25.4001 23.0774ZM17.0273 19.5448V18.3428V18.3658V17.6274V18.3578V18.3209V19.5448Z"
                    fill={fill}
                />
            </svg>
        </SvgIcon>
    );
}
